<template>
  <div>
    <table class="table-borderless">
      <tr v-if="filters.membershipType">
        <td>
          <div class="d-inline-flex align-items-center">
          <span>{{
              variablePositionValueData['memberShipType']
            }}</span>
            <span>
            Membership Type:
          </span>
          </div>
        </td>
        <td class="pr-1">
          <div class="d-inline-flex align-items-start">
            <div class="d-inline-flex align-items-center flex-column">
              <div v-for="{ text, value } in filteredMemberships" :key="value">
                {{ text }}
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <b-card class="border-0">
      <b-row class="mb-3">
        <template v-for="dvName in uniqueDerivedVarNamesToDisplay" :v-key="dvName">
          <b-col md="2" class="mb-3 font-weight-bold">
            {{ getFilterDerivedVarValueTitle(dvName) }} :
          </b-col>
          <b-col md="4" class="mb-3" :v-key="dvName">
            <span v-html="getFilterDerivedVarValueSummary(dvName)" />
          </b-col>
        </template>

        <template v-for="question in filteredQuestionsToDisplay" :v-key="question">
          <b-col md="2" class="mb-3 font_weight_bold">
            {{ question.label }} :
          </b-col>
          <b-col md="4" class="mb-3">
            <span v-html="getFilterVarValueSummary(question)"/>
          </b-col>
        </template>
      </b-row>

    </b-card>
  </div>

</template>

<script>
import DerivedVariables from '@/providers/DerivedVariables';
import {
  QUESTION_TYPES,
  VISA_STATUSES_LABELS,
  VISA_STATUSES_TYPES,
} from '@/store';
import flatten from 'lodash/flatten';
import keyBy from 'lodash/keyBy';

export default {
  name: 'ReportMarkdownFilters',
  props: {
    filters: Object,
    filterValues: Object,
    membershipOptions: Array,
    questionnaire: Object,
  },
  countOfVariables: 0,
  computed: {
    genderOptions: function () {
      return this.$store.state.genderOptions.filter((o) => o.value !== null);
    },
    ethnicityOptions: function () {
      return this.$store.state.ethnicityOptions.filter((o) => o.value !== null);
    },
    specialties: function () {
      return this.$store.state.user &&
      this.$store.state.user.society &&
      Array.isArray(this.$store.state.user.society.specialties)
          ? this.$store.state.user.society.specialties
          : [];
    },
    filteredMemberships: function () {
      if (
          !this.filterValues ||
          !Array.isArray(this.filterValues.membershipTypeIds)
      )
        return [];
      return this.membershipOptions.filter(({value}) =>
          this.filterValues.membershipTypeIds.includes(value)
      );
    },
    filteredQuestions: function () {
      if (
          !this.questions ||
          !this.filters ||
          !Array.isArray(this.filters.variableIds)
      ) {
        return [];
      }
      const variableIds = (this.filters || {}).variableIds || [];
      const questionIds = Object.values(this.variables)
          .filter(({id}) => variableIds.includes(id))
          .map(({question_id}) => question_id);
      return Object.values(this.questions).filter(({id}) =>
          questionIds.includes(id)
      );
    },
    variablePositionValueData: function () {
      let position = 1;
      let data = {};
      if (this.filters.membershipType) {
        data['memberShipType'] = position;
        position += 1;
      }
      this.uniqueDerivedVarNames.forEach((name) => {
        data[name] = position;
        position += 1;
      });
      this.filteredQuestions.forEach(({id}) => {
        data[`question_${id}`] = position;
        position += 1;
      });
      return data;
    },
    uniqueDerivedVarNames: function () {
      return [...new Set(this.filters.derivedVarNames)];
    },
    questions: function () {
      if (!this.questionnaire) {
        return [];
      }
      const qs = flatten(
          this.questionnaire.sections.map((section) => {
            if (!section || !section.questionSections) return [];
            return section.questionSections
                .filter((qs) => !!qs.question)
                .map((qs) => qs.question);
          })
      );
      return keyBy(qs, (q) => q.id);
    },
    variables: function () {
      const vs = flatten(
          Object.values(this.questions).map((question) => {
            return question.variables;
          })
      );
      return keyBy(vs, (v) => v.id);
    },
    uniqueDerivedVarNamesToDisplay: function () {
      let uniqueDerivedVarNamesToDisplay = this.uniqueDerivedVarNames;
      if (uniqueDerivedVarNamesToDisplay.length > 10) {
        uniqueDerivedVarNamesToDisplay = uniqueDerivedVarNamesToDisplay.slice(0, 10);
      }
      return uniqueDerivedVarNamesToDisplay;
    },
    filteredQuestionsToDisplay: function () {
      let filteredQuestionsToDisplay = this.filteredQuestions;
      let uniqueDerivedVarNamesLength = this.uniqueDerivedVarNamesToDisplay.length;
      if (uniqueDerivedVarNamesLength >= 10) {
        return [];
      } else {
        let canDisplay = 10 - uniqueDerivedVarNamesLength;
        if (filteredQuestionsToDisplay.length <= canDisplay) {
          return filteredQuestionsToDisplay;
        }
        return filteredQuestionsToDisplay.slice(0, canDisplay);
      }
    }
  },
  methods: {
    getFilterDerivedVarValueTitle: function (dvName) {
      if (DerivedVariables.userFilterVariables[dvName]) {
        return DerivedVariables.userFilterVariables[dvName].title;
      }
      return '';
    },
    getFilterDerivedVarValueSummary: function (dvName) {
      if (dvName === 'userSpecialtyId') {
        const specialties = this.specialties;
        const checkedSpecialties = specialties.filter(
            (s) => !!this.filterValues.derivedVarValues[`userSpecialtyId_${s.id}`]
        );
        if (checkedSpecialties.length === 1) {
          return `<div class="pl-2">${checkedSpecialties[0].title}</div>`;
        }
        if (checkedSpecialties.length) {
          return `<div class="pl-2">` + checkedSpecialties.map((s) => s.title).join(', ') + `</div>`;
        } else {
          return '<div class="pl-2">[Any]</div>';
        }
      } else if (dvName === 'userGender') {
        const genders = this.genderOptions;
        const checkedGenders = genders.filter(
            (g) => !!this.filterValues.derivedVarValues[`userGender_${g.value}`]
        );
        if (checkedGenders.length === 1) {
          return `<div class="pl-2">${checkedGenders[0].text}</div>`;
        }
        if (checkedGenders.length) {
          return `<div class="pl-2">` + checkedGenders.map((g) => g.text).join(', ') + `</div>`;
        } else {
          return '<div class="pl-2">[Any]</div>';
        }
      } else if (dvName === 'userEthnicity') {
        const ethnicities = this.ethnicityOptions;
        const checkedEthnicities = ethnicities.filter(
            (g) =>
                !!this.filterValues.derivedVarValues[`userEthnicity_${g.value}`]
        );
        if (checkedEthnicities.length === 1) {
          return `<div class="pl-2">${checkedEthnicities[0].text}</div>`;
        }
        if (checkedEthnicities.length) {
          return `<div class="pl-2">` + checkedEthnicities.map((ethn) => ethn.text).join(', ') + `</div>`;
        } else {
          return '<div class="pl-2">[Any]</div>';
        }
      } else if (dvName === 'userZipcode') {
        const displayName = this.filterValues.derivedVarValues['userZipcode']
            ? (
                (this.filterValues.derivedVarValues['userZipcode'] || {}).value ||
                {}
            ).display_name
            : null;
        return `<div class="pl-2">${displayName || '[Any]'}</div>`;
      } else if (dvName === 'userUSVeteran') {
        const value = Object.entries(this.filterValues.derivedVarValues).some(
            ([dvKey, value]) => dvKey.startsWith('userUSVeteran') && value === 1
        )
            ? 'Yes'
            : 'No';
        return `<div class="pl-2">${value}</div>`;
      } else if (dvName === 'userVisaStatus') {
        const visaStatuses = Object.values(VISA_STATUSES_TYPES);
        const checkedStatuses = visaStatuses.filter(
            (status) =>
                !!this.filterValues.derivedVarValues[`userVisaStatus_${status}`]
        );
        if (checkedStatuses.length === 1) {
          return `<div class="pl-2">${checkedStatuses[0]}</div>`;
        }
        if (checkedStatuses.length) {
          return checkedStatuses
              .map((status) => VISA_STATUSES_LABELS[status])
              .join(', ');
        }
        return '<div class="pl-2">[Any]</div>';
      } else if (dvName === 'userMsa') {
        const range = this.filterValues.derivedVarValues['msa_range'];
        return range ? `&plusmn; ${range}%` : '[Any]';
      }

      return '';
    },
    getFilterVarValueSummary: function (q) {
      if (
          q.type === QUESTION_TYPES.SELECT_ANY ||
          q.type === QUESTION_TYPES.SELECT_ONE
      ) {
        const checkedVars = q.variables.filter(
            (v) => !!this.filterValues.variableValues[`${q.id}_${v.id}`]
        );
        if (checkedVars.length === 1) {
          return `<div class="pl-2">${
              checkedVars[0].short_label || checkedVars[0].input_label
          }</div>`;
        }
        if (checkedVars.length) {
          return `<div class="pl-2">` + checkedVars
              .map((v) => (v.short_label ? v.short_label : v.input_label))
              .join(', ') + `</div>`;
        } else {
          return '[Any]';
        }
      } else if (q.type === QUESTION_TYPES.YES_NO) {
        const val = this.filterValues.variableValues[
            `${q.id}_${q.variables[0].id}`
            ];
        const result = val === 1 ? 'Yes' : val === 0 ? 'No' : '[Any]';
        return `<div class="pl-2">${result}</div>`;
      } else if (
          q.type === QUESTION_TYPES.CONFIRMATION ||
          q.type === QUESTION_TYPES.SLIDER
      ) {
        if (q.variables.length === 1) {
          const variable = q.variables[0];
          const prefix = variable.prefix || '';
          const suffix = variable.suffix || '';
          const min = this.filterValues.variableValues[
              `${q.id}_${variable.id}_minmax`
              ].min;
          const max = this.filterValues.variableValues[
              `${q.id}_${variable.id}_minmax`
              ].max;
          let text = '[Any]';
          if (min !== null && max) {
            text = `${prefix}${min} - ${max}${suffix}`;
          } else if (min) {
            text = `At least ${prefix}${min}${suffix}`;
          } else if (max) {
            text = `At most ${prefix}${max}${suffix}`;
          }
          return `<div class="pl-2">${text}</div>`;
        } else {
          const selectedVariables = q.variables.filter(
              (v) => this.filterValues.variableValues[`${q.id}_${v.id}_minmax`]
          );
          const variableToString = (variable) => {
            const prefix = variable.prefix || '';
            const suffix = variable.suffix || '';
            const label = variable.short_label || variable.input_label;
            const variableValue = this.filterValues.variableValues[
                `${q.id}_${variable.id}_minmax`
                ];
            const min = variableValue.min;
            const max = variableValue.max;
            if (min !== null && max) {
              return `${label}: ${prefix}${min} - ${max}${suffix}`;
            } else if (min) {
              return `${label}: At least ${prefix}${min}${suffix}`;
            } else if (max) {
              return `${label}: At most ${prefix}${max}${suffix}`;
            }
            return '';
          };
          if (selectedVariables.length === 0) {
            return '<div class="pl-2">[Any]</div>';
          }
          if (selectedVariables.length === 1) {
            return `<div class="pl-2">${variableToString(
                selectedVariables[0]
            )}</div>`;
          }
          return selectedVariables.map(variableToString).join(', ');
        }
      }
      return q.id;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
